/**
 * Non-secret marker used to signal "an OAuth session exchange is pending" across the
 * redirect boundary between the OAuth callback (server) and the login/onboarding pages
 * (client).
 *
 * This is intentionally its own dependency-free module. The server side
 * (`oauth-helpers.ts` / `google-callback.ts`) that builds the redirect URL sits behind
 * `lib/encryption.ts`, which imports Node's `crypto` and cannot be bundled into client
 * components. Every client-side reader of this marker (`use-session-token.ts`,
 * `login/page.tsx`, `protected-route.tsx`, `use-onboarding-flow.ts`,
 * `use-subscription-check.ts`) must import it from here — not from `oauth-helpers.ts` —
 * so neither side can drift out of sync without also breaking a client bundle.
 */
export const PENDING_SESSION_MARKER_PARAM = 'auth';
export const PENDING_SESSION_MARKER_VALUE = 'pending';
